import { useQuery } from "@tanstack/react-query";
import { Card } from "antd";
import Title from "antd/es/typography/Title";
import React, { useState } from "react";
import LoaderTsx from "../../../Loader.tsx";
import { getRenewalTrends } from "../../Booking/ducks/service";
import YearDropDown from "../../components/YearDropDown";
import StackedBarChart from "./components/StackedBarChart";
import { useDashboardFilterContext } from "../../hooks/DashboardFilterProvider";

const RenewalTrends: React.FC = React.memo(() => {
  const currentYear = new Date().getFullYear();

  const [year, setYear] = useState(currentYear);
  const filterData = useDashboardFilterContext();
  let { queryParams } = filterData;
  const body: any = { year: year }; // example payload

  // queryParams["yeasr"] = year;
  let finalPaload = { ...body, ...queryParams };
 
  const { data: renewalTrendsData, isLoading: isLoading } = useQuery({
    queryKey: ["renewal-trends", finalPaload],
    queryFn: () => getRenewalTrends(finalPaload),
    staleTime: 1000 * 60 * 5, // ✅ 5 minutes
    refetchOnWindowFocus: false, // 👈 disable auto refetch when window regains focus
  });

  return (
    <Card
      style={{
        backgroundColor: "#FFFFFF",
        borderRadius: 8,
        border: "1px solid #E9E9E9",
        boxShadow: "none",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Title
          level={5}
          style={{
            margin: 0,
            color: "#1F5782",
            textTransform: "uppercase",
            fontWeight: 400,
          }}
        >
          <span style={{ fontWeight: 700 }}>Renewal Trends:</span>{" "}
          <span style={{ fontWeight: 400 }}>Last 12 Months</span>
        </Title>

        <YearDropDown actions={setYear} />
      </div>

      {isLoading ? (
        <LoaderTsx height="30vh" />
      ) : (
        <StackedBarChart renewalsData={renewalTrendsData} />
      )}
    </Card>
  );
});

export default RenewalTrends;
